export default {
  async upcoming(config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/staff/repayments/upcoming/${this.user.id}`,
      headers: this.headers,
      ...config,
    });
  },
};
